import { EPaymentMethod } from "../../../../../../../../dependencies/getContent/constants";
import { produce } from "../../../../../../../../../libs/immer";

// dependency injected factory function for sberpay back button props
export var getMapStateToSberPayBackButtonProps = function getMapStateToSberPayBackButtonProps(_ref) {
  var getContent = _ref.getContent;
  return function (getState, setState) {
    var _state$scenario;
    var state = getState();
    if (((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) !== EPaymentMethod.SberPay) throw new Error('not sberpay screen');
    var content = getContent();
    return {
      children: content.sberPayPopup.backButtonText,
      disabled: false,
      onClick: function onClick() {
        setState(produce(function (draft) {
          if (draft.scenario && draft.scenario.type === EPaymentMethod.SberPay && draft.scenario.step === 1) {
            draft.scenario.step = 0;
            return;
          }
          draft.scenario = undefined;
        }));
      }
    };
  };
};